import { useState } from "react";
import { Info } from "lucide-react";
import { MailGuideDialog } from "@/features/shell/MailGuideModal";
import { MailShellOverflowMenu } from "@/features/shell/MailShellOverflowMenu";
import { MobileButton } from "@/mobile/components/ui/MobileButton";

/**
 * Suite / préférences — bas du drawer mobile (hors header réception).
 * Guide, thème, son, légal, déconnexion.
 */
export function MobileNavDrawerSuiteFooter() {
  const [guideOpen, setGuideOpen] = useState(false);

  return (
    <div className="mobile-nav-suite-footer flex flex-col gap-2 px-2 py-2">
      <p className="px-2 text-[11px] font-medium text-[var(--mail-muted)]">Suite & préférences</p>
      <MobileButton
        variant="ghost"
        className="h-auto w-full justify-start gap-2 rounded-lg px-2 py-2 text-left"
        onClick={() => setGuideOpen(true)}
      >
        <Info className="h-4 w-4 shrink-0 text-[var(--mail-muted)]" aria-hidden />
        <span className="text-sm">Guide Aurélia Mail</span>
      </MobileButton>
      <div className="flex items-center gap-2 px-1">
        <span className="min-w-0 flex-1 text-sm text-[var(--mail-text)]">Thème & compte</span>
        <MailShellOverflowMenu menuPlacement="top" />
      </div>
      <MailGuideDialog open={guideOpen} onClose={() => setGuideOpen(false)} />
    </div>
  );
}
